<ng-container *mojoHasFeatureExtension="tasksExtension">
  <ng-container *mojoHasPrivilege="tasksPrivilege">
    <mojo-tasks-page-container
      [hasAnonymization]="hasAnonymization$ | async"
      [entityId]="entityId"
      [entityType]="entityType"
      [sideDrawerConfiguration]="sideDrawerConfiguration"
      [isExpandible]="isExpandible"
      [showLine]="showLine"
      [width]="width"
      [candidate]="candidate"
      [entityTitle]="entityTitle"
      [fromTalentPool]="fromTalentPool"
    ></mojo-tasks-page-container>
  </ng-container>
</ng-container>
